import request from '@/plugins/axios'

//获取图片列表
export function listVideo(params) {
  return request({
    url: '/video/listVideo',
    method: 'get',
    params
  })
}

//获取未整理图片列表
export function listUnclutteredVideo(params) {
  return request({
    url: '/video/listUnclutteredVideo',
    method: 'get',
    params
  })
}

//获取指定图集中图片列表
export function listAtlasVideos(params) {
  return request({
    url: '/video/listAtlasVideos',
    method: 'get',
    params
  })
}

//添加图片
export function addVideo(data) {
  return request({
    url: '/video/addVideo',
    method: 'post',
    data
  })
}

//删除图片
export function deleteVideo(params) {
  return request({
    url: '/video/deleteVideo/' + params,
    method: 'get'
  })
}

//删除图片至回收站
export function removeVideo(params) {
  return request({
    url: '/video/removeVideo/' + params,
    method: 'get'
  })
}

//查询单个图片
export function getVideo(params) {
  return request({
    url: '/video/getVideo/' + params,
    method: 'get'
  })
}

//修改图片信息
export function updateVideo(data) {
  return request({
    url: '/video/updateVideo',
    method: 'post',
    data
  })
}

//绑定图集
export function bindingAtlas(params) {
  return request({
    url: '/video/bindingAtlas',
    method: 'post',
    params
  })
}


//查询多个视频
export function getVideos(params) {
  return request({
    url: '/video/getVideos',
    method: 'get',
    params
  })
}


//恢复删除视频
export function recycleVideo(params) {
  return request({
    url: '/video/recycleVideo',
    method: 'post',
    params
  })
}

//获取视频回收站列表
export function listRecycleVideo(params) {
  return request({
    url: '/video/listRecycleVideo',
    method: 'get',
    params
  })
}